import { BREAKPOINT_MEDIUM_PX } from '@/settings';
import { css } from 'lit';

export const typographyStyles = css`
  :host([part='wholesale']) h1 {
    font-size: 1.5rem;
    font-weight: 600;
  }

  :host([part='retail']) h2 {
    font-size: 1.25rem;
  }

  :host([part='wholesale']) h2 {
    font-size: 1.375rem;
  }

  :host([part='wholesale']) h3 {
    font-size: 1.25rem;
  }

  :host([part='wholesale']) h4 {
    font-size: 1.125rem;
  }

  :host([part='wholesale']) h5 {
    font-size: 1rem;
  }

  @media screen and (min-width: ${BREAKPOINT_MEDIUM_PX}px) {
    :host([part='wholesale']) h1 {
      font-size: 2.25rem;
    }

    :host([part='wholesale']) h2 {
      font-size: 2rem;
    }

    :host([part='wholesale']) h3 {
      font-size: 1.75rem;
    }

    :host([part='wholesale']) h4 {
      font-size: 1.375rem;
    }

    :host([part='wholesale']) h5 {
      font-size: 1.125rem;
    }
  }
`;
